import { render, staticRenderFns } from "./button-item.vue?vue&type=template&id=2b845ee0"
import script from "./button-item.vue?vue&type=script&lang=js"
export * from "./button-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b845ee0')) {
      api.createRecord('2b845ee0', component.options)
    } else {
      api.reload('2b845ee0', component.options)
    }
    module.hot.accept("./button-item.vue?vue&type=template&id=2b845ee0", function () {
      api.rerender('2b845ee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lotto/button-item.vue"
export default component.exports